export enum CreditType {
  BASIC = 'BASIC',
  ADDITIONAL = 'ADDITIONAL',
}
